<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-6"
	>
		<p class="mt-2 text-2xl text-black font-medium mx-auto text-center">
			<span v-if="locale == 'de'">
				Hier werden Ihre unverbindlichen Ein- und/oder Verkaufsinserate
				angezeigt.
			</span>
			<span v-else>
				Your free buy and sell offers will be displayed here.
			</span>
		</p>

		<ui-button
			type="primary"
			class="mt-2 text-lg mx-auto block"
			v-on:click="$bus.$emit('toggle-iframe-modal', $route('offers.create'))"
		>
			<span class="flex items-center">
				<ui-icon name="plus" class="h-7 w-7" stroke-width="2" />
				{{ __("New offer") }}
			</span>
		</ui-button>
		<div class="mt-2 text-2xl text-gray-500 font-medium mx-auto text-center">
			<span v-if="locale == 'de'">
				Warum inserieren? Wir haben da drei Ideen:
			</span>
			<span v-else> Why advertise? We have three ideas: </span>
		</div>

		<div class="md:px-12">
			<div class="flex flex-col sm:flex-row items-stretch justify-center">
				<div
					class="flex-1 md:mx-6 px-6 py-6 rounded-2xl border border-black m-2"
					v-for="(advantage, idx) in advantages"
					:key="idx"
				>
					<div class="flex items-center space-x-4 pb-4 h-12">
						<ui-icon :name="advantage.icon" stroke-width="2" />
						<h2 class="text-2xl font-semibold">
							{{ locale == "de" ? advantage.title : advantage.title_en }}
						</h2>
					</div>
					{{
						locale == "de" ? advantage.description : advantage.description_en
					}}
					<div class="flex items-center space-x-2">
						<ui-icon
							class="h-5 w-5 text-orange-500"
							name="fa-arrow-right"
							stroke-width="2.5"
						/>
						<a
							:href="advantage.href"
							class="pt-3 text-orange-500 underline cursor-pointer"
							@click="handleAdvantageClick($event, advantage)"
						>
							{{
								locale == "de" ? advantage.link_text : advantage.link_text_en
							}}
						</a>
					</div>
				</div>
			</div>

			<div class="mt-6 border-t-2 border-dotted">
				<img :src="imageUrl" class="mx-auto mt-8 opacity-50" />
			</div>
		</div>

		<my-lots-auction-info-modal
			v-if="showAuctionInfoModal"
			v-on:close="showAuctionInfoModal = false"
		></my-lots-auction-info-modal>
	</div>
</template>

<script>
export default {
	methods: {
		handleAdvantageClick(event, advantage) {
			console.log("HANDLE ADVANTAGE", advantage, event);
			if (advantage.modal) {
				event.preventDefault();
				this.showAuctionInfoModal = true;
			}
		},
	},
	data() {
		return {
			showAuctionInfoModal: false,
			advantages: [
				{
					icon: "fa-magnifying-glass",
					title: "Sichtbarkeit",
					description:
						"Inserieren Sie Ihre Ware und zeigen Sie sich potentiellen Handelspartnern. Passende Nachfragen zu Ihren Inseraten werden Ihnen automatisch vorgeschlagen.",
					link_text: "Aktuelle Nachfragen ansehen",
					title_en: "Visibility",
					description_en:
						"Advertise your goods and show yourself to potential trading partners. Suitable requests for your advertisements will be suggested to you automatically.",
					link_text_en: "View current buy offers",
					href: this.$route("search.index"),
				},
				{
					icon: "fa-list-check",
					title: "Management",
					description:
						"Organisieren Sie bequem Ihre Vermarktung über cropspot. Haben Sie stets im Blick, welche Bestände Sie noch zu vermarkten haben und welche Ware Sie schon verkauft haben.",
					link_text: "Kontraktübersicht ansehen",
					title_en: "Management",
					description_en:
						"Organize your marketing conveniently via cropspot. Always keep an eye on which stocks you still have to market and which goods you have already sold.",
					link_text_en: "View contract dashboard",
					href: this.$route("my_contracts.index"),
				},
				{
					icon: "hammer",
					title: "Auktion",
					description:
						"Nehmen Sie über Ihre Inserate an unserer wöchentlichen Auktion teil. Einfach Menge und Wunschpreis auswählen und los gehts!",
					link_text: "Mehr über die Auktion erfahren",
					title_en: "Auction",
					description_en:
						"Take part in our weekly auction via your advertisements. Simply select quantity and desired price and off you go!",
					link_text_en: "Learn more about the auction",
					modal: true,
				},
			],
		};
	},
	computed: {
		imageUrl() {
			return window.baseUrl + "/images/my-lots-empty-sample-content.png";
		},
	},
};
</script>
